/**
 * @file ppde页成员
 * @author FengGuang(fengguang01@baidu.com)
 */
import React, {useMemo} from 'react';
import {Col, Row} from 'antd';
import MemberItem from './MemberItem';
import {IMembersProps} from './types';

const Members: React.FC<IMembersProps> = (props) => {
    const list = props.list;

    const theList = useMemo(() => {
        return list.slice(0, 5);
    }, [list]);

    return (
        <div className="paddle-ppde-members">
            <div className="paddle-ppde-members-flow">
                {theList.map((vlist, index) => (
                    <div key={index}>
                        <Row gutter={[0, 10]}>
                            {vlist.map((item, index2) => (
                                <Col key={index2} xs={24}>
                                    <MemberItem
                                        {...item}
                                        backgroundType={(index + index2) % 3 + 1}
                                    />
                                </Col>
                            ))}
                        </Row>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Members;
